export const type_list = [
    ['endowment_insurance_payment_base', '养老保险缴存基数'],
    ['medical_insurance_payment_base', '医疗保险缴存基数'],
    ['unemployment_insurance_payment_base', '失业保险缴存基数'],
    ['industrial_injury_insurance_payment_base', '工伤保险缴存基数'],
    ['maternity_insurance_payment_base', '生育保险缴存基数'],
    ['supplementary_medical_payment_base', '补充医疗基数'],
    [ 'accumulation_fund_payment_base', '公积金缴存基数']
].map(item => {
    return [item[0] + '_lowest', ...item]
})

export const illegality_val = [null, undefined, '']

export const remark = '因修改后的数据需同步至[薪酬管理]及[薪资发放]模块，请等待约10分钟后再进行查看。'
export const pre_remark_1 = '修改设置后立即生效，未归档的薪酬将按照新规则计算，已归档薪酬不会变化，您确定这样操作吗？'
export const pre_remark_2 = '修改设置后立即生效，您确定这样操作吗？'